import { FaFileInvoiceDollar, FaPix, FaListCheck, FaCreditCard } from "react-icons/fa6";
import SimpleCard from "shared/components/simpleCard/SimpleCard";
import CustomButton from "shared/components/button/CustomButton";
import { getStyleIconeCircular } from "shared/util/functions/style/StyleFunctions";
import { FaMoneyBillWave } from "react-icons/fa";
import { useContext, useEffect, useState } from "react";
import { Fade } from "@material-ui/core";
import SucessoFestivoIcon from "shared/components/icons/SucessoFestivoIcon";
import { UserContext } from "context/UserContext";
import { useGetAdministradoraPossuiAutenticacaoPartnerContaDigital } from "hooks/contaDigital/useGetAdministradoraPossuiAutenticacaoPartnerContaDigital";
import { usePostEnviarCnpjCondominioWhiteListPartner } from "hooks/contaDigital/usePostEnviarCnpjCondominioWhiteListPartner";
import { RequestEnviarCondominioWhiteList } from "types/request/RequestEnviarCondominioWhiteList";
import { usePostCriarAutenticacaoPartnerContaDigital } from "hooks/contaDigital/usePostCriarAutenticacaoPartnerContaDigital";
import { usePostCriarContaDigitalPendente } from "hooks/contaDigital/usePostCriarContaDigitalPendente";

const CadastrarContaDigitalPartner: React.FC = () => {
  const [mostrarConteudo, setMostrarConteudo] = useState(false);
  const [usuarioSolicitouContaDigital, setUsuarioSolicitouContaDigital] = useState(false);
  const { usuarioLogado, condominioContexto } = useContext(UserContext);

  const onSuccessCriarAutenticacaoPartner = async () => {
    await criarContaDigitalGroupCondominios(null).then(() => undefined);
  };

  const onSuccessCriarContaDigital = async () => {
    setUsuarioSolicitouContaDigital(true);
    await enviarCnpjCondominioParaWhiteListPartnerBank().then(() => undefined);
  };

  const enviarCnpjCondominioParaWhiteListPartnerBank = async () => {
    const requestEnviarCondominioWhiteList = {
      cnpjCondominio: condominioContexto?.cnpj,
      razaoSocialCondominio: condominioContexto?.razaoSocial,
      usuarioId: usuarioLogado.id,
    } as RequestEnviarCondominioWhiteList;

    await enviarCnpjWhiteListPartner(requestEnviarCondominioWhiteList).catch((_) => undefined);
  };

  const { data: administradoraPossuiAuthPartnerContaDigital } =
    useGetAdministradoraPossuiAutenticacaoPartnerContaDigital(usuarioLogado.id);

  const { mutateAsync: criarAutenticacaoPartnerContaDigital } = usePostCriarAutenticacaoPartnerContaDigital({
    usuarioLogadoId: usuarioLogado.id,
    onSuccess: onSuccessCriarAutenticacaoPartner,
  });

  const { mutateAsync: criarContaDigitalGroupCondominios } =
    usePostCriarContaDigitalPendente(onSuccessCriarContaDigital);

  const { mutateAsync: enviarCnpjWhiteListPartner } = usePostEnviarCnpjCondominioWhiteListPartner();

  useEffect(() => {
    setMostrarConteudo(true);
  }, []);

  const corIconeCard = "#0d4077";
  const corCirculoIconeCard = "#d5e0ef";

  const renderHeaderConhecaContaDigital = () => {
    return (
      <div className="header-conheca-conta-digital">
        <h1>
          <p className="titulo-conheca-conta-digital">
            Mais autonomia para os síndicos e mais retenção de{" "}
            <span className="underline-gradient">clientes para a sua administradora!</span>
          </p>
        </h1>
        <div className="width-60">
          <p className="font-size-16">
            Bem-vindo ao cadastro da Conta Digital PartnerBank integrada ao seu ERP, o jeito simples e seguro de cuidar
            dos seus serviços bancários!
          </p>
        </div>
      </div>
    );
  };

  const renderCardsContaDigital = () => {
    return (
      <>
        <div className="d-flex justify-content-around">
          <SimpleCard id={"card-efetuar-pagamentos"} largura={"14vw"} altura={"40vh"}>
            {renderCardEfetuarPagamentos()}
          </SimpleCard>
          <SimpleCard id={"card-extrato-bancario"} largura={"14vw"} altura={"40vh"}>
            {renderCardExtratoBancario()}
          </SimpleCard>
          <SimpleCard id={"card-gerenciar-contas-pagar"} largura={"14vw"} altura={"40vh"}>
            {renderCardGerenciarDespesas()}
          </SimpleCard>
          <SimpleCard id={"card-pix"} largura={"14vw"} altura={"40vh"}>
            {renderCardPix()}
          </SimpleCard>
          <SimpleCard id={"card-cartao-credito"} largura={"14vw"} altura={"40vh"}>
            {renderCardCartaoDeCredito()}
          </SimpleCard>
        </div>
        <div className="d-flex justify-content-center mt-4">{renderBotaoSolicitarCadastro()}</div>
      </>
    );
  };

  const renderCardEfetuarPagamentos = () => {
    return (
      <div className="item-card">
        <div style={getStyleIconeCircular(corCirculoIconeCard)}>
          <FaMoneyBillWave size={25} color={corIconeCard} />
        </div>
        <h3>
          <b>Efetuar pagamentos</b>
        </h3>
        <p>Permita que seu cliente efetue pagamentos de forma autônoma</p>
      </div>
    );
  };

  const renderCardExtratoBancario = () => {
    return (
      <div className="item-card">
        <div style={getStyleIconeCircular(corCirculoIconeCard)}>
          <FaFileInvoiceDollar size={25} color={corIconeCard} />
        </div>
        <h3>
          <b>Conferir extratos bancários</b>
        </h3>
        <p>Através da conta digital seu cliente consegue conferir extratos</p>
      </div>
    );
  };

  const renderCardGerenciarDespesas = () => {
    return (
      <div className="item-card">
        <div style={getStyleIconeCircular(corCirculoIconeCard)}>
          <FaListCheck size={25} color={corIconeCard} />
        </div>
        <h3>
          <b>Gerenciar as contas a pagar</b>
        </h3>
        <p>Garanta transparência e permita que seu cliente gerencia as contas a pagar</p>
      </div>
    );
  };

  const renderCardPix = () => {
    return (
      <div className="item-card">
        <div style={getStyleIconeCircular(corCirculoIconeCard)}>
          <FaPix size={25} color={corIconeCard} />
        </div>
        <h3>
          <b>Transferências PIX e TED</b>
        </h3>
        <p>Seu cliente tem autonomia para realizar transferências Pix e TED</p>
      </div>
    );
  };

  const renderCardCartaoDeCredito = () => {
    return (
      <div className="item-card">
        <div style={getStyleIconeCircular(corCirculoIconeCard)}>
          <FaCreditCard size={25} color={corIconeCard} />
        </div>
        <h3>
          <b>Cartão de crédito pré pago</b>
        </h3>
        <p>Disponibilize um cartão de crédito online e físico ao seu cliente</p>
      </div>
    );
  };

  const renderBotaoSolicitarCadastro = () => {
    return (
      <div style={{ width: "40%" }}>
        <CustomButton
          className="mb-2"
          id="solicitar-cadastro-conta-digital"
          label="Solicitar cadastro"
          onClick={() => solicitarContaDigital()}
          size="lg"
          bigSize
        />
      </div>
    );
  };

  const solicitarContaDigital = async () => {
    if (!administradoraPossuiAuthPartnerContaDigital) {
      await criarAutenticacaoPartnerContaDigital(usuarioLogado.id).catch((_) => undefined);
    } else {
      await criarContaDigitalGroupCondominios(null).catch((_) => undefined);
    }
  };

  const renderSolicitacaoDeCadastro = () => {
    return (
      <Fade in={mostrarConteudo} timeout={700}>
        <div>
          <div className="container-header-conheca-conta-digital">{renderHeaderConhecaContaDigital()}</div>
          <div className="container-cards-conheca-conta-digital">
            <div>{renderCardsContaDigital()}</div>
          </div>
        </div>
      </Fade>
    );
  };

  const renderSolicitacaoDeCadastroConcluida = () => {
    return (
      <Fade in={usuarioSolicitouContaDigital} timeout={300}>
        <div className="cadastro-conta-digital-iniciado">
          <SucessoFestivoIcon />
          <div className="titulo-conheca-conta-digital mb-2">
            O cadastro da <span style={{ color: "#0d4077" }}>Conta digital</span> foi iniciado!
          </div>
          <p className="font-size-16">
            A sua solicitação da Conta Digital foi iniciada! Em breve você receberá um e-mail com informações para os
            próximos passos e dar início a uma nova fase na sua gestão.
          </p>
        </div>
      </Fade>
    );
  };

  return <>{usuarioSolicitouContaDigital ? renderSolicitacaoDeCadastroConcluida() : renderSolicitacaoDeCadastro()}</>;
};

export default CadastrarContaDigitalPartner;
